<template>
  <div>
    <Background />
    <div class="relative">
      <PageHeader :hide-downloads="true"></PageHeader>

      <Top />
      <Flow />
      <Content>
        <template #inputs>
          <Payment price="税込 980円" />
        </template>
      </Content>

      <PageFooter />
    </div>
  </div>
</template>

<script>
import Background from '../../../../../components/Payments/Program/Fellowship/Chie/Background';
import PageHeader from '../../../../../components/Payments/Program/Alliance/GlobeEnglishSchool/Header';

import Top from '../../../../../components/Payments/Program/Alliance/GlobeEnglishSchool/Top';
import Flow from '../../../../../components/Payments/Program/Alliance/GlobeEnglishSchool/FlowPayment';
import Content from '../../../../../components/Payments/Program/Alliance/GlobeEnglishSchool/Content';
import Payment from '../../../../../components/Payments/Program/Alliance/GlobeEnglishSchool/Payment';

import PageFooter from '../../../../../components/LP/Footer';

export default {
  components: {
    Background,
    PageHeader,
    Top,
    Flow,
    Content,
    Payment,
    PageFooter,
  },
};
</script>
